import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Classnames from 'classnames';

import IconButton from '../button/IconButton';
import Icon from '../icon/Icon';

require('./style.scss');


export default class Carousel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      slides: this.convertSlides(props),
      currentSlideIndex: props.autoCenter ? -1 : 0,  //
      leftOffset: props.autoCenter ? -999 : 0,
    };

    this.slideCount = Carousel.getSlideCount(this.state.slides);
    this.slideRefs = new Map();
    this.slideIntervalHandler = null;
    this.containerWidth = 0;
  }

  componentDidMount() {
    this.setAutoplayHandler(true);
  }

  componentWillReceiveProps(nextProps) {
    this.slideCount = Carousel.getSlideCount(nextProps.children);
    this.setState({ slides: this.convertSlides(nextProps) });
  }

  componentWillUnmount() {
    if (this.slideIntervalHandler !== null) window.clearInterval(this.slideIntervalHandler);
  }

  getSlideWidths() {
    return _.map(Array.from(this.slideRefs.values()), slideRef =>
      slideRef.getBoundingClientRect().width);
  }

  getCenteringOffset(slideIndex) {
    if (!this.props.autoCenter) {
      return 0;
    }

    return (this.containerWidth - this.getSlideWidths()[slideIndex]) / 2;
  }

  setContainerWidth(width) {
    this.containerWidth = width;
  }

  setAutoplayHandler(enable) {
    if (this.slideIntervalHandler !== null) window.clearInterval(this.slideIntervalHandler);

    if (this.props.autoplay && enable) {
      this.slideIntervalHandler = setInterval(() => this.nextSlide(), this.props.duration);
    } else {
      this.slideIntervalHandler = null;
    }
  }

  registerSlideRef(index, slideRef) {
    if (slideRef) {
      this.slideRefs.set(index, slideRef);
    }
  }

  convertSlides(props) {
    return React.Children.map(props.children, child => (
      <div
        className="carousel-slide"
        ref={slideRef => this.registerSlideRef(child.key, slideRef)}
        style={{ width: this.props.slideWidth }}
      >
        {child}
      </div>));
  }

  previousSlide() {
    const slideCount = this.slideCount;
    const scrollAmount = this.props.scrollAmount;
    const slideWidths = this.getSlideWidths();

    let currentSlideIndex = this.state.currentSlideIndex - scrollAmount;
    currentSlideIndex = currentSlideIndex < 0 ? slideCount - 1 : currentSlideIndex;

    if (currentSlideIndex % scrollAmount !== 0) {
      currentSlideIndex -= currentSlideIndex % scrollAmount;
    }

    const centeringOffset = this.getCenteringOffset(this.state.currentSlideIndex);
    const leftOffset = -_.sum(
      _.slice(slideWidths, 0, this.state.currentSlideIndex)) + centeringOffset;

    if (this.props.onSlideChange) {
      this.props.onSlideChange(this.state.slides[currentSlideIndex], currentSlideIndex);
    }

    this.setState({ currentSlideIndex, leftOffset });
  }

  nextSlide() {
    const slideCount = this.slideCount;
    const scrollAmount = this.props.scrollAmount;
    const slideWidths = this.getSlideWidths();

    let currentSlideIndex = this.state.currentSlideIndex + scrollAmount;
    currentSlideIndex = currentSlideIndex >= slideCount ? 0 : currentSlideIndex;
    const centeringOffset = this.getCenteringOffset(this.state.currentSlideIndex);
    const leftOffset = -_.sum(
      _.slice(slideWidths, 0, this.state.currentSlideIndex)) + centeringOffset;

    if (this.props.onSlideChange) {
      this.props.onSlideChange(this.state.slides[currentSlideIndex], currentSlideIndex);
    }

    this.setState({ currentSlideIndex, leftOffset });
  }

  render() {
    return (
      <div
        className={Classnames(
          'carousel', this.props.className,
          { banner: this.props.banner },
          )}
      >
        {this.props.arrows ? <IconButton
          className="previous-button"
          outline
          icon={<Icon name="angle-left" />}
          onClick={() => this.previousSlide()}
        /> : null}

        <div
          className={Classnames('carousel-slide-container', { 'arrow-padding': this.props.arrows })}
          ref={containerRef =>
            this.setContainerWidth(containerRef ? containerRef.getBoundingClientRect().width : 0)}
        >
          <div
            className="carousel-window"
            style={{ left: this.state.leftOffset, width: '99999px' }}
            onMouseEnter={() => this.setAutoplayHandler(false)}
            onMouseLeave={() => this.setAutoplayHandler(true)}
          >
            {this.state.slides}

            <div className="clearfix" />
          </div>
        </div>

        {this.props.arrows ? <IconButton
          className="next-button"
          outline
          icon={<Icon name="angle-right" />}
          onClick={() => this.nextSlide()}
        /> : null}
      </div>
    );
  }
}

/* Static functions */

Carousel.getSlideCount = children =>
  React.Children.count(children);

/* Prop type definitions and default prop definitions */
Carousel.propTypes = {
  arrowColor: PropTypes.string,
  arrows: PropTypes.bool,
  autoplay: PropTypes.bool,
  banner: PropTypes.bool,
  className: PropTypes.string,
  duration: PropTypes.number,
  onSlideChange: PropTypes.func,
  scrollAmount: PropTypes.number,
  autoCenter: PropTypes.bool,
  slideWidth: PropTypes.number,
};

Carousel.defaultProps = {
  arrowColor: '#000000',
  duration: 2000,
  scrollAmount: 1,
};

Carousel.Slide = props =>
  <div
    className={Classnames('carousel-slide', props.className)}
    style={props.style}
  >
    {props.children}
  </div>;

Carousel.Slide.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
};



// WEBPACK FOOTER //
// ./app/components/common/carousel/Carousel.jsx